import React from "react";
import sanitizeHtml from "sanitize-html";
import { replaceWithUnicode } from "../shared/string";

interface Props {
  title: string;
  stepBySteps: string[];
}

const StepByStep = ({ title, stepBySteps }: Props) => (
  <fieldset className="w-full h-full flex-1 bg-white ml-8 md:ml-16 lg:ml-24 px-8 lg:max-w-1/3 border-2 border-form-border rounded-lg">
    <legend className="px-2 lg:ml-0 uppercase text-xl font-bold text-brand-primary-20">
      {replaceWithUnicode(title)}
    </legend>

    <ul className=" mb-4 py-4">
      {stepBySteps.map((step: string, index: number) => (
        <li key={step} className="flex flex-col">
          <div className="flex items-center -ml-16">
            <div className="flex flex-col -ml-2 mr-4">
              <div className="flex w-20 h-20 items-center justify-center rounded-full bg-step-by-step-number-bg text-brand-primary-20 text-5xl font-bold cursor-default">
                {index + 1}
              </div>
            </div>

            <p
              className="mb-0 text-brand-primary-20 text-xl font-bold"
              dangerouslySetInnerHTML={{
                __html: sanitizeHtml(step)
              }}
            />
          </div>
          {index < stepBySteps.length - 1 && (
            <div className="h-6 -ml-10 bg-white">
              <div className="w-2 h-full border-r-2 border-form-border border-dashed"></div>
            </div>
          )}
        </li>
      ))}
    </ul>
  </fieldset>
);

export default StepByStep;

